<template>
  <img :src="src" :style="imageStyle" @load="onImageLoad" :alt="alt"/>
</template>

<script>
export default {
  props: {
		src: {
			type: String
		},
		max: {
			type: String
		},
		alt: {
			type: String
		}
	},

	data() {
    return {
      imageStyle: {
        height: 'auto', // Default height
        width: 'auto' // Width to maintain aspect ratio
      }
    };
  },
	created() {
		console.log("MH:",this.max)
	},
  methods: {
    onImageLoad(event) {
      // Calculate the height of the image
      const imageHeight = event.target.height;
      // Set the actual height if it's smaller than the maximum
      if (imageHeight < parseInt(this.max)) {
        this.imageStyle.height = imageHeight + 'px';
      } else {
				this.imageStyle.height = '100%';
			}
    }
  }
};
</script>
